import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "./Mainframe.css";
import { Helmet } from 'react-helmet';
import Header from '../../Headers/Header';
import LandingPage from './LandingPage';
import { useAuth } from '../../../auth/auth';
import { getSafeRedirectPath } from '../../../utils/safeRedirect';

const Mainframe = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = getSafeRedirectPath(location.state?.from);
  const { user, userType, loading } = useAuth();
  const [shouldShowLanding, setShouldShowLanding] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (loading) return;

    if (user) {
      if (returnTo) {
        navigate(returnTo, { replace: true });
        return;
      }

      let redirectLocation = null;

      if (userType === 'Company' && user.town && user.state) {
        redirectLocation = `${user.town}, ${user.state}`;
      } else {
        redirectLocation = localStorage.getItem('spiggl_last_search_location');
      }

      if (redirectLocation) {
        const loc = encodeURIComponent(redirectLocation);
        navigate(`/search-results/${encodeURIComponent('All Contractors')}/${loc}`, { replace: true });
        return;
      }
    }

    setShouldShowLanding(true);
    setChecked(true);
  }, [user, userType, loading, navigate, returnTo]);

  if (!checked && !shouldShowLanding) {
    return null;
  }

  return (
    <div className="mainframe">
      <Header />
      <Helmet titleTemplate="%s">
        <title>Spiggl — Find and Review Local Contractors</title>
        <meta name="description" content="Search local contractors by trade and town, read reviews from Spiggl users, and message, schedule and pay in one place." />
      </Helmet>
      <LandingPage />
    </div>
  );
};

export default Mainframe;
